import Cookies from 'js-cookie'
import { fetchWithRetry } from './fetch.js'

async function fetchCsrfToken() {
  if (!navigator.onLine) {
    return
  }

  try {
    const response = await fetch('/auth/csrf-token')
    if (!response.ok) {
      console.error('There was a problem with the fetch csrf token operation')
    }
    return await response.text()
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error)
  }
}

async function refreshToken() {
  const tokenUrl = `/auth/refresh`
  try {
    await fetch(tokenUrl, {
      method: 'POST',
    })
    return 'cookie-token'
  } catch (error) {
    console.error('Error fetching token:', error.response ? error.response.data : error.message)
    throw error
  }
}

async function getUserDetails() {
  const json = Cookies.get('user_details')
  return json ? JSON.parse(json) : null
}

/**
 * Inserts one record in the specified table. Multiple record insertion is not supported by this method.
 * @param {*} tableName
 * @param {*} data
 * @returns
 */
async function post(url, data) {
  var response = await fetchWithRetry(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  const json = await response.json()

  if (json.success === false) {
    console.error('Server Error:', json.errorMessage)
    throw new Error(json.errorMessage)
  }

  if (json.warningMessage) {
    console.warn('Server Warning:', json.warningMessage)
  }

  return json.data
}

export default {
  getUserDetails,
  fetchCsrfToken,
  refreshToken,
  post,
}
